import { useCallback, useEffect, useMemo, useState } from "react"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import DefaultBanner from '../../../../images/menu_banner_default.webp'
import DefaultLogo from '../../../../images/menu_logo_default.webp'
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Stack from '@mui/material/Stack';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import { getImage } from "../../../../utils/filesystem"
import Styles from './Styles/Header.module.css'
import { WEEK_DAYS } from "../../../../utils/dates";
import { DELIVERY_METHODS, STORE_STATES } from "../../../../utils/structures";

export default function Header(props) {
    const [logo, setLogo] = useState(undefined)
    const [cover, setCover] = useState(undefined)

    const [infoOpen, setInfoOpen] = useState(false)
    const [showDelivery, setShowDelivery] = useState(true)

    const [storeStateDelivery, setStoreStateDelivery] = useState(null)
    const [storeStateTakeaway, setStoreStateTakeaway] = useState(null)

    const deliveryButtonIsDisabled = useMemo(() => {
        const hasDelivery = props.menu.deliveryOptions ? props.menu.deliveryOptions.some(option => option === DELIVERY_METHODS.delivery) : false
        const hasOpenDays = props.menu.schedule.delivery.reduce((prev, curr) => curr.active || prev, false)

        return !hasDelivery || !hasOpenDays
    }, [props.menu.schedule.delivery, props.menu.deliveryOptions])


    const takeawayButtonIsDisabled = useMemo(() => {
        const hasTakeaway = props.menu.deliveryOptions ? props.menu.deliveryOptions.some(option => option === DELIVERY_METHODS.takeaway) : false
        const hasInPlace = props.menu.deliveryOptions ? props.menu.deliveryOptions.some(option => option === DELIVERY_METHODS.inPlace) : false
        const hasOpenDays = props.menu.schedule.takeaway.reduce((prev, curr) => curr.active || prev, false)

        return (!hasTakeaway && !hasInPlace) || !hasOpenDays
    }, [props.menu.schedule.takeaway, props.menu.deliveryOptions])


    // Today
    const today = useMemo(() => new Date(), [])
    const todayTakeawaySchedule = props.menu.schedule.takeaway[today.getDay()]
    const todayDeliverySchedule = props.menu.schedule.delivery[today.getDay()]
    const currentTime = today.getHours() * 100 + today.getMinutes()

    const getStoreImages = useCallback(async () => {
        const reqCover = await getImage(props.menu.userid + "/banner.webp")
        setCover(reqCover ? URL.createObjectURL(reqCover) : DefaultBanner)

        const reqLogo = await getImage(props.menu.userid + "/logo.webp")
        setLogo(reqLogo ? URL.createObjectURL(reqLogo) : DefaultLogo)
    }, [props.menu])

    const getStoreState = useCallback((schedule, isDelivery) => {



        if (schedule.openAllDay) {
            return STORE_STATES.openAllDay
        }

        if (schedule.time.length <= 1) {
            const openTime = parseInt(schedule.time[0].start)
            const closeTime = parseInt(schedule.time[0].end)

            if (currentTime > openTime && currentTime < closeTime) {
                return schedule.active ? STORE_STATES.open : STORE_STATES.dayOff
            }

            if (openTime > closeTime && currentTime <= 2400 && currentTime > openTime) {
                return schedule.active ? STORE_STATES.open : STORE_STATES.dayOff
            }

            // Yesterday
            const yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            const yesterdaySchedule = isDelivery ? props.menu.schedule.delivery[yesterday.getDay()] : props.menu.schedule.takeaway[yesterday.getDay()]

            const yesterdayCloseTime = parseInt(yesterdaySchedule.time[yesterdaySchedule.time.length - 1].end)
            const yesterdayOpenTime = parseInt(yesterdaySchedule.time[yesterdaySchedule.time.length - 1].start)

            if (yesterdayCloseTime < yesterdayOpenTime && currentTime < yesterdayCloseTime) {
                return yesterdaySchedule.active ? STORE_STATES.openSinceYesterday : STORE_STATES.dayOff
            }

            // En este punto el local esta cerrado
            if (openTime > currentTime) {
                return schedule.active ? STORE_STATES.notOpenYet : STORE_STATES.dayOff
            } else {
                return schedule.active ? STORE_STATES.alreadyClose : STORE_STATES.dayOff
            }


        } else {
            const openTime = [parseInt(schedule.time[0].start), parseInt(schedule.time[1].start)]
            const closeTime = [parseInt(schedule.time[0].end), parseInt(schedule.time[1].end)]

            if ((currentTime > openTime[0] && currentTime < closeTime[0]) ||
                (currentTime > openTime[1] && currentTime < closeTime[1])) {
                return schedule.active ? STORE_STATES.open : STORE_STATES.dayOff
            }

            if (openTime[1] > closeTime[1] && currentTime <= 2400 && currentTime > openTime[1]) {
                return schedule.active ? STORE_STATES.openSinceYesterday : STORE_STATES.dayOff
            }

            // Yesterday
            const yesterday = new Date()
            yesterday.setDate(today.getDate() - 1)
            const yesterdaySchedule = isDelivery ? props.menu.schedule.delivery[yesterday.getDay()] : props.menu.schedule.takeaway[yesterday.getDay()]

            const yesterdayCloseTime = parseInt(yesterdaySchedule.time[yesterdaySchedule.time.length - 1].end)
            const yesterdayOpenTime = parseInt(yesterdaySchedule.time[yesterdaySchedule.time.length - 1].start)

            if (yesterdayCloseTime < yesterdayOpenTime && currentTime < yesterdayCloseTime) {
                return yesterdaySchedule.active ? STORE_STATES.openSinceYesterday : STORE_STATES.dayOff
            }

            // En este punto el local esta cerrado
            if (openTime[1] > currentTime) {
                return schedule.active ? STORE_STATES.notOpenYet : STORE_STATES.dayOff
            } else {
                return schedule.active ? STORE_STATES.alreadyClose : STORE_STATES.dayOff
            }
        }
    }, [currentTime, props.menu.schedule, today])

    useEffect(() => {
        getStoreImages()
        const deliveryState = getStoreState(todayDeliverySchedule, true)
        const takeAwayState = getStoreState(todayTakeawaySchedule, false)

        setStoreStateTakeaway(takeAwayState)
        setStoreStateDelivery(deliveryState)

        props.setStoreState({
            delivery: deliveryState,
            takeaway: takeAwayState,
        })
    }, [todayDeliverySchedule, todayTakeawaySchedule, getStoreState, props.setStoreState, getStoreImages])

    useEffect(() => {

        let deliveryOpen = true, takeawayOpen = true
        if (storeStateDelivery === STORE_STATES.dayOff
            || storeStateDelivery === STORE_STATES.alreadyClose
            || storeStateDelivery === STORE_STATES.notOpenYet) {
            deliveryOpen = false
        }

        if (storeStateTakeaway === STORE_STATES.dayOff
            || storeStateTakeaway === STORE_STATES.alreadyClose
            || storeStateTakeaway === STORE_STATES.notOpenYet) {
            takeawayOpen = false
        }

        if (deliveryOpen && !takeawayOpen) {
            setShowDelivery(true)
        }
        if (!deliveryOpen && takeawayOpen) {
            setShowDelivery(false)
        }

    }, [storeStateDelivery, storeStateTakeaway])

    const getNextOpenDay = schedule => {
        const day = new Date()

        day.setDate(day.getDate() + 1)
        for (let i = 0; i < 8; i++) {
            if (schedule[day.getDay()].active) {
                return day.getDay()
            }
            day.setDate(day.getDate() + 1)
        }

        return null
    }

    const StoreScheduleInfo = (params) => {
        const nextOpenDay = getNextOpenDay(params.schedule)

        if (nextOpenDay !== null) {
            switch (params.state) {
                case STORE_STATES.dayOff:
                    return (
                        <>
                            <Typography className={Styles.storeClosed}>Cerrado hoy</Typography>
                            <Typography>{" Abre el " + WEEK_DAYS[nextOpenDay]}</Typography>
                        </>
                    )

                case STORE_STATES.alreadyClose:
                    return (
                        <>
                            <Typography className={Styles.storeClosed}>Cerrado ahora</Typography>
                            <Typography>{" Abre el " + WEEK_DAYS[nextOpenDay]}</Typography>
                        </>
                    )

                case STORE_STATES.notOpenYet:
                    return (
                        <>
                            <Typography className={Styles.storeClosed}>Cerrado ahora</Typography>
                            <Typography>
                                {params.todaySchedule.time.length > 1 && currentTime > params.todaySchedule.time[0].start ?
                                    " Abre hoy " + params.todaySchedule.time[1].start.slice(0, 2) + ':' + params.todaySchedule.time[1].start.slice(2,)
                                    :
                                    " Abre hoy " + params.todaySchedule.time[0].start.slice(0, 2) + ':' + params.todaySchedule.time[0].start.slice(2,)}
                            </Typography>
                        </>
                    )

                case STORE_STATES.open:
                    return (
                        <>
                            <Typography className={Styles.storeOpen}>Abierto ahora</Typography>
                            <Typography>
                                {params.todaySchedule.time.length > 1 && currentTime > params.todaySchedule.time[0].end ?
                                    " Cierra " + params.todaySchedule.time[1].end.slice(0, 2) + ':' + params.todaySchedule.time[1].end.slice(2,)
                                    :
                                    " Cierra " + params.todaySchedule.time[0].end.slice(0, 2) + ':' + params.todaySchedule.time[0].end.slice(2,)}
                            </Typography>
                        </>
                    )
                case STORE_STATES.openAllDay:
                    return <Typography className={Styles.storeOpen}>Abierto todo el dia</Typography>

                case STORE_STATES.openSinceYesterday:
                    const yesterday = new Date()
                    yesterday.setDate(today.getDate() - 1)
                    const yesterdaySchedule = params.schedule[yesterday.getDay()]

                    return (
                        <>
                            <Typography className={Styles.storeOpen}>Abierto ahora</Typography>
                            <Typography>
                                {" Cierra " + yesterdaySchedule.time[yesterdaySchedule.time.length - 1].end.slice(0, 2) + ':' + yesterdaySchedule.time[yesterdaySchedule.time.length - 1].end.slice(2,)}
                            </Typography>
                        </>
                    )

                default:
                    return null
            }
        }

        return <>
            <Typography className={Styles.storeClosed}>Cerrado</Typography>
            <Typography>Sin horarios definidos</Typography>
        </>
    }


    return (
        <>
            <div>
                <div className={Styles.imagesContainer}>
                    <div className={Styles.cover} style={{ backgroundImage: 'url(' + cover + ')' }}></div>
                    <img src={logo} className={Styles.logo} />

                    <div className={Styles.socialMediaContainer}>
                        {props.menu.socialMedia.ig !== '' ?
                            <IconButton onClick={() => window.open('https://www.instagram.com/' + props.menu.socialMedia.ig, '_blank')}>
                                <InstagramIcon sx={{ color: 'hsl(' + props.menu.color + ', 40%, 40%)' }} fontSize="large" />
                            </IconButton>
                            : null}
                        {props.menu.socialMedia.tw !== '' ?
                            <IconButton onClick={() => window.open('https://www.twitter.com/' + props.menu.socialMedia.tw, '_blank')}>
                                <TwitterIcon sx={{ color: 'hsl(' + props.menu.color + ', 40%, 40%)' }} fontSize="large" />
                            </IconButton>
                            : null}
                        {props.menu.socialMedia.fb !== '' ?
                            <IconButton onClick={() => window.open('https://www.facebook.com/' + props.menu.socialMedia.fb, '_blank')}>
                                <FacebookIcon sx={{ color: 'hsl(' + props.menu.color + ', 40%, 40%)' }} fontSize="large" />
                            </IconButton>
                            : null}
                    </div>
                </div>

                <Stack className={Styles.info} spacing={2}>

                    <Typography variant="h4" fontWeight={600}>{props.menu.title}</Typography>
                    <Typography className={Styles.caption}>{props.menu.description}</Typography>

                    <Stack alignItems='center' justifyContent='space-between' direction='row'>

                        <Stack direction='row' flexWrap='wrap' alignItems='center' justifyContent='space-evenly' sx={{ width: '100%' }}>

                            <Stack alignItems='center' sx={{ width: '100%', maxWidth: '300px', marginRight: '10px' }}>
                                <ToggleButtonGroup
                                    color="primary"
                                    value={showDelivery}
                                    exclusive
                                    onChange={(event, newAlignment) => { if (newAlignment !== null) { setShowDelivery(newAlignment) } }}
                                    fullWidth
                                >
                                    <ToggleButton sx={{ borderRadius: '15px', padding: '5px 10px' }} value={true}
                                        disabled={deliveryButtonIsDisabled}
                                    >
                                        Delivery</ToggleButton>
                                    <ToggleButton sx={{ borderRadius: '15px', padding: '5px 10px' }} value={false}
                                        disabled={takeawayButtonIsDisabled}
                                    >
                                        Para retirar</ToggleButton>
                                </ToggleButtonGroup>

                                <Stack direction='row' justifyContent='space-evenly' alignItems='center' spacing={1} flexWrap='wrap'
                                    sx={{ padding: '10px 0px', borderBottom: '1px solid gray', width: '100%' }}>

                                    {showDelivery ?
                                        <StoreScheduleInfo
                                            schedule={props.menu.schedule.delivery}
                                            state={storeStateDelivery}
                                            todaySchedule={todayDeliverySchedule}
                                        />
                                        :
                                        <StoreScheduleInfo
                                            schedule={props.menu.schedule.takeaway}
                                            state={storeStateTakeaway}
                                            todaySchedule={todayTakeawaySchedule}
                                        />}
                                </Stack>

                            </Stack>

                            <div className={Styles.deliveryCost}>
                                <Typography variant="body2">Costo de envío</Typography>

                                {props.menu.deliveryCost.from < 0 ?
                                    <Typography>A consultar</Typography> :
                                    props.menu.deliveryCost.free === 0 ?
                                        <Typography >Gratis</Typography>
                                        : props.menu.deliveryCost.from === props.menu.deliveryCost.to ?
                                            <Typography fontWeight={700}>{props.menu.deliveryCost.from}</Typography>
                                            : <>
                                                <Typography variant="h6">${props.menu.deliveryCost.from} - ${props.menu.deliveryCost.to}</Typography>
                                            </>}

                                {props.menu.deliveryCost.free > 0 ?
                                    <>
                                        <Divider sx={{ width: '100%', m: 1 }} />
                                        <Typography><b>Gratis</b> comprando <b>${props.menu.deliveryCost.free}</b> o más</Typography>
                                    </> : null}

                            </div>
                        </Stack>

                        <IconButton onClick={() => setInfoOpen(true)}>
                            <InfoOutlinedIcon fontSize="large" sx={{ color: 'hsl(' + props.menu.color + ',40%, 40%)' }} />
                        </IconButton>

                    </Stack>
                </Stack >
            </div >

            <Divider sx={{ backgroundColor: props.menu.color, m: 1 }} />

            <Dialog
                fullWidth={true}
                maxWidth="sm"
                open={infoOpen}
                onClose={() => setInfoOpen(false)}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogActions>
                    <IconButton autoFocus onClick={() => setInfoOpen(false)}>
                        <CloseIcon fontSize="large" />
                    </IconButton>
                </DialogActions>

                <DialogTitle id="responsive-dialog-title" variant="h4">
                    {props.menu.title}
                </DialogTitle>

                <DialogContent>
                    {props.menu.address !== '' ?
                        <>
                            <Divider sx={{ m: 1 }} />
                            <Typography variant="h5">Dirección</Typography>
                            <Typography>{props.menu.address}</Typography>
                            <Divider sx={{ m: 1 }} />
                        </> : null}

                    <Typography variant="h5">Horarios</Typography>

                    {!props.menu.deliveryOptions ? <Typography variant="h6">Sin horarios disponibles</Typography> :
                        <>
                            <ToggleButtonGroup
                                sx={{ width: '100%', justifyContent: 'center', margin: '15px 0px' }}
                                color="primary"
                                value={showDelivery}
                                exclusive
                                onChange={(event, newAlignment) => { if (newAlignment !== null) { setShowDelivery(newAlignment) } }}
                            >
                                {props.menu.deliveryOptions.some(val => val === DELIVERY_METHODS.delivery) ? <ToggleButton value={true}>Delivery</ToggleButton> : null}
                                {props.menu.deliveryOptions.some(val => val === DELIVERY_METHODS.takeaway) ? <ToggleButton value={false}>Para retirar</ToggleButton> : null}
                                {props.menu.deliveryOptions.some(val => val === DELIVERY_METHODS.inPlace) ? <ToggleButton value={false}>Comer en el lugar</ToggleButton> : null}

                            </ToggleButtonGroup>


                            {(showDelivery ? props.menu.schedule.delivery : props.menu.schedule.takeaway).map((day, index) => {
                                const state = showDelivery ? storeStateDelivery : storeStateTakeaway
                                const currentDayIndex = state === STORE_STATES.openSinceYesterday ? index === 6 ? 0 : index + 1 : index

                                return (
                                    <div key={index}>
                                        <Stack direction='row' justifyContent='space-between' alignItems='center'>
                                            <Typography sx={currentDayIndex === today.getDay() ? { fontWeight: '700' } : null}>
                                                <span>{WEEK_DAYS[index]}</span>
                                            </Typography>

                                            <Stack>
                                                {!day.active ? <Typography sx={currentDayIndex === today.getDay() ? { fontWeight: '700' } : null}>Cerrado</Typography> :
                                                    day.openAllDay ? <Typography sx={currentDayIndex === today.getDay() ? { fontWeight: '700' } : null}>Abre todo el dia</Typography> :
                                                        day.time.map((dayTime, i) => {
                                                            return (
                                                                <Typography key={i} sx={currentDayIndex === today.getDay() ? { fontWeight: '700' } : null}>
                                                                    {dayTime.start.slice(0, 2) + ':' + dayTime.start.slice(2,) + '-' + dayTime.end.slice(0, 2) + ':' + dayTime.end.slice(2,)}
                                                                </Typography>
                                                            )
                                                        })}
                                            </Stack>
                                        </Stack>
                                        <Divider sx={{ margin: '5px 0px' }} />
                                    </div>
                                )
                            })}
                        </>}

                </DialogContent>
            </Dialog>
        </>
    )
}

